export default __webpack_public_path__ + "static/use-case-1-247b8dba8f18c4de47f3d0c7f1ccec2a.png";